export default {
  //基础sdk
  base: {
    url: '//static.vhallyun.com/jssdk/vhall-jssdk-base/1.2.8/vhall-msg-1.2.8.js'
  },
  //播放器sdk
  player: {
    name: 'VhallPlayer',
    url: '//static.vhallyun.com/jssdk/vhall-jssdk-player/2.7.4/vhall-jssdk-player-2.7.4.js'
  },
  //聊天sdk
  chat: {
    name: 'VhallChat',
    url: '//static.vhallyun.com/jssdk/vhall-jssdk-chat/2.1.12/vhall-jssdk-chat-2.1.12.js'
  },
  //互动sdk
  interaction: {
    name: 'VhallRTC',
    url: '//static.vhallyun.com/jssdk/vhall-jssdk-interaction/3.2.8/vhall-jssdk-interaction-hybrid-3.2.8.js'
  },
  //文档sdk
  doc: {
    name: 'VHDocSDK',
    url: '//static.vhallyun.com/jssdk/vhall-jssdk-doc/3.6.1/vhall-jssdk-doc-3.6.1.js'
  },
  questionnaire: {
    name: 'VHall_Questionnaire_Service',
    url: '//s3.e.vhall.com/common-static/middle/questionnaire/1.3.2/questionnaire_service.js',
    defer: true // 新增属性，延迟执行
  },
  exam: {
    name: "ExamTemplateServer",
    url: "//s3.e.vhall.com/common-static/vhall-form/1.1.1/vhall-form-vue.js"
  }
};
